
<div [ngClass]="display === false ? 'hide-div' : 'display-div'" class="skip-to-main">
    <a id="skip-content" tabindex="1" aria-label="Skip to main content" href="javascript:void(0)" class="skip-link" (click)="focusFormDiv()">{{'SKIP_TO_MAIN_CONTENT' | translate}}</a>
</div>